import TableSalesConsultation from './components/TableSalesConsultation/TableSalesConsultation.vue'
import formSales from '@/views/private/realestate/salesinquiry/components/formSales/formSales.vue'
import DetailsSales from '../salesinquiry/components/detailssales/detailssales.vue'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import Roles from '@/shared/utils/roles'
import PermisionMixin from '@/store/module/permission/mixin'

export default {
  components: {TableSalesConsultation, formSales, DetailsSales},
  mixins: [ PermisionMixin ],
  name: 'SalesConsultation',
  data () {
    return {
      flDetails: false,
      tablereload: 0,
      roles: Roles,
      selectedComissao: {},
      contaId: ''

    }
  },
  methods: {
    edit (obj) {
      this.selectedComissao = obj
      this.flDetails = true
    },
    deleteCommission (id) {
      CommissionRepository.DeleteComissao(id)
        .then(Response => {
          this.consultacomissao = Response.data.data
          this.tablereload++
          this.$refs.tableGridComission.Delete(Response)
        })
        .catch(() => {})
    },
    GetFilter (id) {
      this.$refs.tableCommissionCheck.updateCorretor(id)
    },
    updateTable (id) {
      this.$refs.tableCommissionCheck.updateTable(id)
    },
    getAll () {
      this.$refs.tableCommissionCheck.filterOn = false
      this.$refs.tableCommissionCheck.onLoad()
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesconsultation/salesconsultation.js